import { render } from "./Modal.vue?vue&type=template&id=43c34c4c"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"
script.render = render

export default script